import { Typography, Button, Box, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';


const ScrollAnimation = () => {
  const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);
  const heroNavWrapperRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const screenHeight = window.innerHeight;


    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsHeroNavVisible(entry.isIntersecting);
                const navbar = document.querySelector(".navbar.alt");
                if (navbar) {
                    if (!entry.isIntersecting) {
                        navbar.style.marginTop = "0px";
                    } else {
                        navbar.style.marginTop = "-100px";
                    }
                }
            },
            { threshold: 0.01 }
    );

    if (heroNavWrapperRef.current) {
      observer.observe(heroNavWrapperRef.current);
    }

    return () => {
      if (heroNavWrapperRef.current) {
        observer.unobserve(heroNavWrapperRef.current);
      }
    };
  }, []);


  return (
    <div className="App">

      <ResponsiveAppBarAlt />

      <main>

        <Box className="heroWrapper subpage" id="start">

          <img src="Immobilien-verkaufen.webp" className='herobackimg' />
          <Box className='heroWrapperLayer'></Box>
          <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>

          </Container>

          <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
            <HashLink className='navItemHero' smooth to="/#leistungen">Leistungen</HashLink>
            <HashLink className='navItemHero' smooth to="/#notare">Notare</HashLink>
            <HashLink className='navItemHero' smooth to="/team">Team</HashLink>
            <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
            <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
          </Box>

          {/* <div className="heroCTAWrapper">
            <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
          </div> */}
        </Box>


        <Box className="mainWrapper">

          <Container maxWidth="lg" className="subPageContainerThin">

            <HashLink className='breadcrumb' smooth to="/#leistungen">Leistungen</HashLink>
            <Typography variant='h1' className='subTitle'>Immobilie kaufen oder verkaufen</Typography>


            <Box className="intendTextWrapper">
              <Box className="textintendInnerWrapper">
                <Typography variant='body1' className='sectionText'>Der erste Kauf einer Immobilie als Eigenheim oder als Kapitalanlage wirft oft viele Fragen auf. Unsere Aufgabe als Notare ist es, zeitnah einen Kaufvertragsentwurf zu erstellen und all Ihre Fragen im Beurkundungstermin zu beantworten. Im Anschluss stellen wir einen reibungslosen Übergang des Immobilieneigentums sicher.</Typography>
                <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/purchase">Kaufvertrag Formular</HashLink></Button>
                <hr className='hoeizontalLine' />
                <Typography variant='body1' className='sectionText'>
                Wenn der Käufer den Kauf über einen Kredit bei einer Bank finanziert, wird die Bank eine Kreditsicherheit in Form einer Grundschuld verlangen. Auch die Bestellung der Grundschuld übernimmt der Notar. Dies kann regelmäßig unmittelbar im Anschluss an die Unterzeichnung des Kaufvertrages im gleichen Termin erfolgen.
              </Typography>
              <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/mortgage">Grundschuld Formular</HashLink></Button>
              </Box>
            </Box>

          </Container>


                            <Box className="map" id="map">
                                <Box className="contactMap">
                                    {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=false&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true"></iframe> */}

                                    <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe>

                                </Box>

                                {/* <Container maxWidth="lg" id="routelink">
                                    <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://www.google.com/maps/dir//Notarin%20Dr.%20Antonia%20Harbecke,%20Holzgasse%2029-33,%2053721%20Siegburg" target="_blank">hier</a>.</Typography>
                                </Container> */}

                            </Box>



          <Box className="section bannergrey" id="kontakt">
            <Container maxWidth="lg" className="container" id="kontakt">
              <Box className="kontaktGrid">
                <Box className="kontaktLeftSide">
                  <Typography variant='h2' className='sectionTitle white'>
                    Sie haben Fragen?  <br />
                    Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                  </Typography>
                  <Typography variant='body1' paragraph className='whiteText'>
                    Harbecke & Thelen Notare<br />
                    Holzgasse 29 - 33<br />
                    Siegburg 53721<br />
                  </Typography>
                </Box>
                <Contactform />
              </Box>
            </Container>
          </Box>

        </Box>

      </main >
      <Footer />
    </div >
  );
};

export default ScrollAnimation;